import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/bg.jpg'

import { guides } from '../../data'

export default function HelpGuides() {
  return (
    <>
    <Navbar/> 
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">Guides & Support</h4>
                          <p className="text-muted mb-0">General and business related question and answer are here,</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Help Center</Link></li>
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Guides</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row">
            {guides.map((item,index)=>{
              return(
                <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                    <h5>{item.title}</h5>
                    <ul className="list-unstyled mt-4 mb-0">
                      {item.feature.map((el,index)=>{
                        return(
                          <li className="mt-2" key={index}><Link to="#" className="text-muted"><i className="mdi mdi-arrow-right text-primary me-2"></i>{el}</Link></li>
                        )
                      })}
                    </ul>
                </div>
              )
            })}
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
